export enum LoginEventsNameE {
  LOGIN_USER = 'login-user',
  OFFLINE_USER = 'offline-user',
  ONLINE_USER = 'online-user',
  ALL_USERS = 'all-users',
  FORCE_DISCONNECT = 'force-disconnect',
  USER_ACTIVITY = 'user-activity',
  USER_AWAY = 'user-away',
  USER_BACK = 'user-back',
  AGENT_BLOCKED = 'agent-blocked',
  AGENT_UNBLOCKED = 'agent-unblocked',
  BLOCK_AGENT = 'block-agent',
  UNBLOCK_AGENT = 'unblock-agent',
  BLOCK_REJECTED = 'block-rejected',
  BLOCK_CONFIRMED = 'block-confirmed',
  UNBLOCK_CONFIRMED = 'unblock-confirmed',
}
